export const CLEAR_STATE = 'SHIPPING_PARTNER.CREATE.CLEAR_STATE';
export const RESET_ERROR = "SHIPPING_PARTNER.CREATE.RESET_ERROR";
